module.exports = __webpack_public_path__ + "assets/img/block-right-hover-ecb66dba.png";